export const TABLET = 769;
export const DESKTOP = 1024;
